export default __webpack_public_path__ + "static/media/msoffice.af227fe9.png";